// extracted by mini-css-extract-plugin
module.exports = {"videoLoopV2":"VideoLoopV2_videoLoopV2___1exG","videoPlayer":"VideoLoopV2_videoPlayer___G247","visuallyShowVideo":"VideoLoopV2_visuallyShowVideo__HR2nP"};